/**
 * Guardia para campos de precio del formulario de catálogo.
 *
 * El sanitizador `decimalMoney` de shared/numeric descarta el signo '-' en
 * silencio: tipear (o pegar) "-500" llega al draft como "500" y se guarda
 * positivo sin aviso. Detectamos el signo en el texto crudo del input para
 * mostrar un aviso mientras el valor saneado sigue fluyendo al draft.
 *
 * Se usa `includes` y no `startsWith`: "50-0" también pierde el '-' al
 * sanitizar y quedaría "500" igualmente corrupto.
 */
export const NEGATIVE_PRICE_MESSAGE = 'Los precios no pueden ser negativos.';

export const rawPriceInputHadMinusSign = (raw: string): boolean => raw.includes('-');
